import React from "react";
import { useIntl } from "react-intl";
import { timeFormat } from "@dvsproj/ipat-core/formatter";

function SavingInfo({ saveStatus, lastSaveDate }) {
  const { formatMessage } = useIntl();

  const label = React.useMemo(() => {
    const timeLabel = lastSaveDate
      ? `${formatMessage({
          id: "texts.header.savingTime.title",
        })} ${timeFormat(lastSaveDate)}`
      : null;
    switch (saveStatus) {
      case "saving":
        return formatMessage({ id: "texts.header.savingLabel" }) ?? "saving";
      case "disconnect":
        return timeLabel;
      default:
        return timeLabel;
    }
  }, [formatMessage, lastSaveDate, saveStatus]);

  if (saveStatus == null) return null;

  return (
    <div className={`save-status ${saveStatus}`}>
      {label ??
        formatMessage({ id: "texts.header.notSavedLabel" }) ??
        "plan not saved"}
    </div>
  );
}

export default SavingInfo;
